import { jsonHash } from "@north-beam/nb-common";

import {
  type BenchmarkIndicatorRow,
  type UniversalBenchmarksQuery,
  type UniversalBenchmarksStage,
} from "./types";

export function buildBenchmarkKey(id: string, query: UniversalBenchmarksQuery) {
  const {
    level,
    attributionModel: atm,
    attributionWindow: atw,
    accountingMode: acm,
    breakdowns: br,
    filters,
  } = query;

  const f = jsonHash(filters);

  return `${id}/${level}/${atm}/${atw}/${acm}/${f}/${br.join("|")}`;
}

export function isPositiveChange(row: BenchmarkIndicatorRow) {
  return (
    (row.positiveTrend === "up" && row.current >= row.target) ||
    (row.positiveTrend === "down" && row.current <= row.target)
  );
}

export function isIndicatorRowsOfStage(
  row: BenchmarkIndicatorRow,
  stage: UniversalBenchmarksStage,
) {
  if (stage === "blended") {
    return !(row.metricId.endsWith("Ft") || row.metricId.endsWith("Rtn"));
  }

  if (stage === "new") {
    return row.metricId.endsWith("Ft");
  }

  if (stage === "returning") {
    return row.metricId.endsWith("Rtn");
  }

  return false;
}

export function filterIndicatorRowsByStage(
  rows: BenchmarkIndicatorRow[],
  stage: UniversalBenchmarksStage | undefined,
) {
  if (!stage) {
    return rows;
  }

  const result = rows.filter((e) => isIndicatorRowsOfStage(e, stage));

  if (result.length === 0) {
    result.push(...rows);
  }

  return result;
}

export function getStageFromMetricId(
  metricId: string,
): UniversalBenchmarksStage {
  if (metricId.endsWith("Ft")) {
    return "new";
  }
  if (metricId.endsWith("Rtn")) {
    return "returning";
  }

  return "blended";
}
